export const SHOW = 'community/MENU_SHOW';
export const HIDE = 'community/MENU_HIDE';
export const LOGOUT = 'community/MENU_LOGOUT';
